import { useMemo } from "react";
import { MONTHS_LONG, WEEKDAYS_LETTER, datePart, makeDate, parts, rangeDays, startOfWeek, weekday } from "../../lib/date";
import { useUi } from "../../state/ui";
import { useVisibleEvents } from "./common";
import "./YearView.css";

/** Twelve month grids; days with events are marked; clicking a day opens it. */
export function YearView() {
  const ui = useUi();
  const year = parts(ui.date).y;
  const { events, holidays } = useVisibleEvents(makeDate(year, 1, 1), makeDate(year + 1, 1, 1));
  const busy = useMemo(() => new Set(events.map((e) => datePart(e.start))), [events]);
  const holidaySet = useMemo(() => new Set(holidays.map((h) => h.date)), [holidays]);
  const weekStart = ui.me.settings.weekStart;

  return (
    <div className="yv">
      {Array.from({ length: 12 }, (_, i) => {
        const first = makeDate(year, i + 1, 1);
        const days = rangeDays(startOfWeek(first, weekStart), 42);
        return (
          <section key={i} className="yv-month" aria-label={MONTHS_LONG[i]}>
            <h3>{MONTHS_LONG[i]}</h3>
            <div className="yv-grid">
              {days.slice(0, 7).map((d) => (
                <span key={`h${d}`} className="yv-dow">
                  {WEEKDAYS_LETTER[weekday(d)]}
                </span>
              ))}
              {days.map((d) => {
                const other = parts(d).m !== i + 1;
                const cls = ["yv-day", other && "other", d === ui.today && "today", !other && busy.has(d) && "busy", !other && holidaySet.has(d) && "holiday"].filter(Boolean).join(" ");
                return (
                  <button key={d} className={cls} onClick={() => { ui.setDate(d); ui.setView("day"); }} aria-label={d}>
                    {parts(d).d}
                  </button>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
}
